import { FC, memo } from 'react'
import { NodeProps, Position } from '@xyflow/react'
import DataObjectIcon from '@mui/icons-material/DataObject'
import PsychologyIcon from '@mui/icons-material/Psychology'
import Chip from '@mui/material/Chip'
import Box from '@mui/material/Box'
import BaseNode from './BaseNode'
import { AiCallNodeData } from '../types'
import { WORKFLOW } from '../tokens'

const AiCallNode: FC<NodeProps> = ({ id, data, selected }) => {
  const nodeData = data as AiCallNodeData
  const subtitle = nodeData.model || 'Select a model...'
  // Mirrors the autocomplete gate: only an object example exposes output structure.
  const structureKnown =
    !!nodeData.outputExample &&
    typeof nodeData.outputExample === 'object' &&
    !Array.isArray(nodeData.outputExample)

  return (
    <BaseNode
      nodeType="ai_call"
      icon={<PsychologyIcon fontSize="small" />}
      label={nodeData.label}
      nodeId={id}
      subtitle={subtitle}
      selected={selected}
      handles={[
        { type: 'target', position: Position.Top },
        { type: 'source', position: Position.Bottom },
      ]}
    >
      <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
        {nodeData.expectJson && (
          <Chip
            label="JSON"
            size="small"
            icon={structureKnown ? <DataObjectIcon sx={{ fontSize: 13 }} /> : undefined}
            sx={{
              'height': 22,
              'fontSize': 11,
              'fontWeight': 500,
              'background': WORKFLOW.ai_call.bg,
              'color': WORKFLOW.ai_call.accent,
              '& .MuiChip-icon': { color: WORKFLOW.ai_call.accent },
            }}
          />
        )}
      </Box>
    </BaseNode>
  )
}

export default memo(AiCallNode)
